'use client'

import { IconTrashX } from '@tabler/icons-react'
import Image from 'next/image'
import { pathOr } from 'ramda'

import {
  getProductPrices,
  ProductTypes,
  useProductCard
} from 'modules/products'
import Button from 'shared/ui/Button/Button'
import IconButton from 'shared/ui/IconButton'

import styles from './ProfileSaleOrdersRepeatProduct.module.scss'

interface ProfileSaleOrdersRepeatProductProps {
  product: ProductTypes
  onRemoveProduct?: (product: ProductTypes) => void
  onReplaceProduct?: (product: ProductTypes) => void
}

const ProfileSaleOrdersRepeatProduct = ({
  product,
  onRemoveProduct,
  onReplaceProduct
}: ProfileSaleOrdersRepeatProductProps) => {
  const { unitDetails, name, nameDescriptionShort, nameShort } = useProductCard(
    {
      product,
      productPath: product.slug
    }
  )

  const { currentPrice, promoPrice, defaultPrice } = getProductPrices(product)

  const productName = nameDescriptionShort || name || nameShort

  const productImage = pathOr(
    '/static/photo-placeholder.svg',
    ['files', 0, 'thumbnailPathSmall'],
    product
  )

  const handleRemoveProduct = () => {
    onRemoveProduct?.(product)
  }

  const handleReplaceProduct = () => {
    onReplaceProduct?.(product)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.productWrapper}>
        <Image src={productImage} alt={productName} width={78} height={78} />
        <div className={styles.insideWrapper}>
          <div className={styles.productDetails}>
            <div className={styles.producerName}>{nameShort}</div>
            <div className={styles.productName}>{productName}</div>
            <div className={styles.productUnitDetails}>{unitDetails}</div>
          </div>

          <div className={styles.priceWrapper}>
            {promoPrice && (
              <div
                className={styles.oldPrice}
                dangerouslySetInnerHTML={{ __html: defaultPrice }}
              />
            )}
            <div
              className={styles.currentPrice}
              dangerouslySetInnerHTML={{ __html: currentPrice }}
            />
          </div>
        </div>
      </div>
      {onRemoveProduct && (
        <IconButton
          onClick={handleRemoveProduct}
          aria-label={`Usuń produkt ${name}`}
          variant='transparent'
          size='small'
        >
          <IconTrashX className={styles.trashIcon} />
        </IconButton>
      )}
      {onReplaceProduct && (
        <Button variant='primary' size='small' onClick={handleReplaceProduct}>
          Zamień
        </Button>
      )}
    </div>
  )
}

export default ProfileSaleOrdersRepeatProduct
